// extracted by mini-css-extract-plugin
export default {"component":"NFTTier_component__0FZ8V","nftTiersImg":"NFTTier_nftTiersImg__npda9"};